var map = {
	"./": [
		"9210"
	],
	"./Group": [
		"736d",
		"chunk-3ef62fca"
	],
	"./Group.vue": [
		"736d",
		"chunk-3ef62fca"
	],
	"./Picture": [
		"ac55",
		"chunk-cac1b34a"
	],
	"./Picture.vue": [
		"ac55",
		"chunk-cac1b34a"
	],
	"./RectShape": [
		"43dc",
		"chunk-cfacd118"
	],
	"./RectShape.vue": [
		"43dc",
		"chunk-cfacd118"
	],
	"./VButton": [
		"dcb2",
		"chunk-2142818a"
	],
	"./VButton.vue": [
		"dcb2",
		"chunk-2142818a"
	],
	"./VText": [
		"d02c",
		"chunk-64871868"
	],
	"./VText.vue": [
		"d02c",
		"chunk-64871868"
	],
	"./component-list": [
		"4e67"
	],
	"./component-list.js": [
		"4e67"
	],
	"./index": [
		"9210"
	],
	"./index.js": [
		"9210"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0d53";
module.exports = webpackAsyncContext;